import { makeStyles } from "@material-ui/core/styles";
import { FC, KeyboardEvent, useState } from "react";
import { DialogTitle, Box } from "@material-ui/core";
import { MyDialog } from "../../Ui/MyDialog";
import { CustomButton } from "../../Ui/CustomButton";
import MandateText from "./MandateText";
import MandateSignatureControl from "./MandateSignatureControl";

const useStyles = makeStyles((theme) => ({
  contractContainer: {
    height: "100%",
    maxHeight: "100%",
    overflow: "auto",
    border: "1px solid lightgrey",
    borderRadius: 5,
    padding: theme.spacing(1),
  },
  button: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: theme.spacing(2, 0),
  },
}));

interface ContractPropsInterface {
  open: boolean;
  contractTemplate: string;
  title: string;
  handleClose(): void;
  handleSendSignature(signatureData: string): void;
  loading?: boolean;
}

const Mandate: FC<ContractPropsInterface> = (props) => {
  const {
    open,
    contractTemplate,
    handleClose,
    title,
    handleSendSignature,
    loading,
  } = props;
  const [signatureDataUrl, setSignatureDataUrl] = useState("");
  const classes = useStyles();

  const handleUploadSignature = (fileDataUrl: string) => {
    setSignatureDataUrl(fileDataUrl);
  };

  const handleSaveSignature = (signatureDataUrl: string) => {
    setSignatureDataUrl(signatureDataUrl);
  };

  const sendSignature = () => {
    handleSendSignature(signatureDataUrl);
  };

  const handleKeyPress = (event: KeyboardEvent<HTMLFormElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      sendSignature();
    }
  };

  const handleCloseModal = () => {
    if (loading) return;
    handleClose();
  };

  return (
    <MyDialog
      open={open}
      onClose={handleCloseModal}
      fullWidth
      maxWidth="md"
      isNotClosable
    >
      <MandateText
        template={contractTemplate}
        className={classes.contractContainer}
      />

      <form onKeyPress={handleKeyPress}>
        <MandateSignatureControl
          handleUploadSignature={handleUploadSignature}
          signatureImage={signatureDataUrl}
          handleSaveSignature={handleSaveSignature}
          disabled={loading}
          title={title}
        />
      </form>

      <Box className={classes.button}>
        <CustomButton
          type="button"
          variant="primary"
          onClick={sendSignature}
          label="save"
          loading={loading}
          fullWidthMobile
        />
      </Box>
    </MyDialog>
  );
};

export default Mandate;
